class RepositorySdgs {
  constructor({ _id, url, code, title }) {
    this.id = _id;
    this.url = url;
    this.code = code;
    this.title = title;
  }
}

export default RepositorySdgs;
